import moment from "moment";
import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "./SampleModel";
import AnalysisModel from "./AnalysisModel";
import AnalyteModel from "./AnalyteModel";
import AnalyteResultStatusLogModel from "./AnalyteResultStatusLogModel";
import InstrumentInstanceModel from "./InstrumentInstanceModel";
import InstrumentJigModel from "./InstrumentJigModel";
import MeasureUnitModel from "./MeasureUnitModel";
import AnalyteResultStatusLogCollection from "@/collections/lab/AnalyteResultStatusLogCollection";
export default class AnalyteResultModel extends LabServiceModel {
  modelName() {
    return "analyte-result";
  }
  icon() {
    return "result";
  }
  defaults() {
    return {
      analysis: null,
      analysis_id: null,
      analyte: null,
      analyte_id: null,
      analyte_result_status_logs: [],
      batch_index: 0,
      created_at: null,
      created_by: null,
      current_analyte_result_status_log: null,
      deleted_at: null,
      formatted_result: null,
      id: null,
      instrument_instance: null,
      instrument_instance_id: null,
      instrument_jig: null,
      instrument_jig_id: null,
      jig_index: 0,
      raw_result: null,
      sample: null,
      sample_id: null,
      schedulable_task: null,
      schedulable_task_id: null,
      schedulable_task_type: null,
      unit_of_measure: null,
      unit_of_measure_id: null,
      updated_by: null,
      updated_at: null
    };
  }
  mutations() {
    return {
      analysis_id: val => this.nullStringMutator(val),
      analyte_id: val => this.nullStringMutator(val),
      batch_index: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val),
      formatted_result: val => this.nullStringMutator(val),
      id: val => this.nullStringMutator(val),
      instrument_instance_id: val => this.nullStringMutator(val),
      instrument_jig_id: val => this.nullStringMutator(val),
      jig_index: val => this.nullStringMutator(val),
      raw_result: val => this.nullStringMutator(val),
      sample_id: val => this.nullStringMutator(val),
      schedulable_task_id: val => this.nullStringMutator(val),
      schedulable_task_type: val => this.nullStringMutator(val),
      unit_of_measure_id: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val)
    };
  }
  getAnalysis() {
    return this.getRelatedModel(AnalysisModel, "analysis");
  }
  getAnalyte() {
    return this.getRelatedModel(AnalyteModel, "analyte");
  }
  getCurrentAnalyteResultStatusLog() {
    return this.getRelatedModel(
      AnalyteResultStatusLogModel,
      "current_analyte_result_status_log"
    );
  }
  getAnalyteResultStatusLogs() {
    return this.getRelatedCollection(
      new AnalyteResultStatusLogCollection(),
      "analyte_result_status_logs"
    );
  }
  getInstrumentInstance() {
    return this.getRelatedModel(InstrumentInstanceModel, "instrument_instance");
  }
  getInstrumentJig() {
    return this.getRelatedModel(InstrumentJigModel, "instrument_jig");
  }
  getSample() {
    return this.getRelatedModel(SampleModel, "sample");
  }
  setStatus(new_status_id) {
    return new Promise((resolve, reject) => {
      const current_status_id = this.getCurrentAnalyteResultStatusLog().getAnalyteResultStatus()
        .id;

      if (current_status_id !== new_status_id) {
        const new_status_log = new AnalyteResultStatusLogModel({
          analyte_result_id: this.id,
          analyte_result_status_id: new_status_id,
          start_date: moment().format("YYYY-MM-DD HH:mm:ss")
        });

        return new_status_log.save().then(
          () => {
            return resolve(new_status_log);
          },
          () => {
            return reject("Selected analyte result status could not be set");
          }
        );
      }
    });
  }
  getUnitOfMeasure() {
    return this.getRelatedModel(MeasureUnitModel, "unit_of_measure");
  }
  cloneCreate() {
    const attrs = this.cloneAttributes(null, null, [
      "id",
      "schedulable_task",
      "sample",
      "analysis",
      "analyte",
      "instrument_instance",
      "instrument_jig",
      "unit_of_measure",
      "created_by",
      "updated_by",
      "created_at",
      "updated_at",
      "deleted_at"
    ]);

    if (this.analyte && this.analyte.name === "Completion") {
      attrs.formatted_result = attrs.raw_result ? "completed" : null;
    }

    const temp = new AnalyteResultModel(attrs);

    return temp.save();
  }
}
